/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outside_Point_3Inputs */

const en_outside_point_3 = /** @type {(inputs: Outside_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No direct integrations: one door, logged both ways`)
};

/**
* | output |
* | --- |
* | "No direct integrations: one door, logged both ways" |
*
* @param {Outside_Point_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const outside_point_3 = /** @type {((inputs?: Outside_Point_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outside_Point_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outside_point_3(inputs)
});